export const ROUTE_REWRITES: Record<string, string[]> = {
  'window/dashboard/tab': ['live-monitor', 'live-monitor-page'],
};
